import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const CheckListIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue6b1'}</MuiIcon>
    );
}